import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/axiosAuth";

export const fetchWholesaleProducts = createAsyncThunk(
  "api/wholesaleProducts/fetch",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`/api/WholesaleProducts`);
      return { rows: response.data || [] };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const wholesaleProductsSlice = createSlice({
  name: "wholesaleProducts",
  initialState: { rows: [], status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWholesaleProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchWholesaleProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.rows = action.payload.rows;
      })
      .addCase(fetchWholesaleProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "حدث خطأ غير متوقع";
      });
  },
});

export default wholesaleProductsSlice.reducer;
export const selectWholesaleProductsRows = (state) =>
  state.wholesaleProducts.rows;
export const selectWholesaleProductsStatus = (state) =>
  state.wholesaleProducts.status;
export const selectWholesaleProductsError = (state) =>
  state.wholesaleProducts.error;
